import React, { useState, useEffect } from 'react';
import './pages_documentos.css';
import { getDatabase, ref, get } from 'firebase/database';
import firebaseApp from '../adm/admin/firebaseConfig';
import { Box } from '@mui/material';
import TitleSection from '../utils/TittleTheme';
import DataTable from '../utils/TabelaLicitacoes';

export default function ArqLicitacoes() {
    const [newsData, setNewsData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const databaseInstance = getDatabase(firebaseApp);
                const noticiasRef = ref(databaseInstance, `licitacoesDocumentos`);

                const snapshot = await get(noticiasRef);
                const data = snapshot.val();

                if (data) {
                    const newsArray = Object.keys(data).map((key) => {
                        const item = data[key];

                        // --- TRATAMENTO ROBUSTO PARA O CAMPO "OUTROS" (Array ou Link Único) ---
                        let outrosProcessed = [];
                        if (Array.isArray(item.outros)) {
                            outrosProcessed = item.outros; // [{ nome, link }]
                        } else if (typeof item.outros === 'string' && item.outros.trim() !== '') {
                            outrosProcessed = [{ nome: 'OUTROS ARQUIVOS', link: item.outros }];
                        } else if (item.outrosDoc) {
                            outrosProcessed = [{ nome: 'OUTROS ARQUIVOS', link: item.outrosDoc }];
                        }

                        return {
                            id: key,
                            title: item.titulo || '',
                            numero: item.numero || '',
                            data: item.data || '', // Padrão: YYYY-MM-DD
                            descricao: item.descricao || '',
                            modalidade: item.modalidade || '',
                            hrefs: {
                                edital: item.editalDoc || null,
                                dfd: item.dfdDoc || null,
                                etp: item.etpDoc || null,
                                pesquisaMercado: item.pesquisaMercadoDoc || null,
                                autorizacao: item.autorizacaoDoc || null,
                                proposta: item.propostaDoc || null,
                                contrato: item.contratoDoc || null,
                                documentacao: item.documentacaoDoc || null,
                                projetoBasico: item.projetoBasicoDoc || null,
                                outros: outrosProcessed // Array estruturado de objetos { nome, link }
                            }
                        };
                    });

                    // --- ORDENAÇÃO DECRESCENTE POR DATA (MAIS RECENTES PRIMEIRO) ---
                    const sortedData = newsArray.sort((a, b) => {
                        if (!a.data) return 1;
                        if (!b.data) return -1;
                        return b.data.localeCompare(a.data);
                    });

                    setNewsData(sortedData);
                }
            } catch (error) {
                console.error('Erro ao carregar documentos:', error);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <Box sx={{ padding: { xs: 2, md: 3 }, maxWidth: '1200px', mx: 'auto' }}>
            <TitleSection 
                title={'LICITAÇÕES'} 
                subtitle={'Documentos e informações sobre processos licitatórios'} 
                share={true} 
            />

            <DataTable data={newsData} />
        </Box>
    );
}